import { useSelector } from 'react-redux';
import { getShowConfirmationPage } from '../../../selectors/tools';
import DTRefundShippingThenSendMacroNode from '../NodeGroups/DTCopyTextSendMacro/DTRefundShippingThenSendMacroNode/DTRefundShippingThenSendMacroNode';

const RefundShippingThenSendMacro = () => {
  const showConfirmationPage = useSelector(getShowConfirmationPage);

  return (
    <DTRefundShippingThenSendMacroNode
      showConfirmation={showConfirmationPage}
      message={'The order shipping amount has been refunded.'}
    />
  );
};

export default RefundShippingThenSendMacro;
